import React from 'react';
import ClientDiscussion from './ClientDiscussion';
import ClientRouteTemplate from './ClientRouteTemplate';

const ClientDiscussionRoute = (props) => (
  <ClientRouteTemplate 
    {...props}
    Component={ClientDiscussion}
    componentName="Discussion"
  />
);

export default ClientDiscussionRoute;
